module.exports = __webpack_public_path__ + "img/fp-info.3f2355a5.webp";